module.exports = __webpack_public_path__ + "media/goforajourney/img/barcelona-card-h-120b241d1a10c82604e1dc10f89414e4.webp";